/**
 * @author xiaohuangmao
 * @date 2020-09-09
 * @desc 内容预览
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from "@/tool";
import { sys_endpoint, sys_ali_bucket, sys_ali_key } from '@/constants/constants_env'
import PlayerContainer, { Layer } from "griffith";
import SwiperCore, { Navigation, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import {documentColumns, downLoadColumns} from "./columns";
let { Session } = utils_tool
import "./index.less";

const { WizTag, WizTypography, WizDivider, WizIcon, WizTable } = component_tool;
const { Title } = WizTypography;
const { WizContainer, modelUtils, ossFileUtils } = framework_tool;
const {getOssUrlBySuffix} = ossFileUtils

import {getDetailRecord,} from '@/containers/content/util'

SwiperCore.use([Navigation, Autoplay]);


class ContentPreview extends WizContainer {
  componentName = "ContentPreview";

  constructor(props) {
    super(props);
    this.detailInfo = getDetailRecord(props.history);
    this.state = {
      record: this.detailInfo,
    };
  }

  _componentDidMount() {
    window.scrollTo(0, 0);

    this.doAction({
      path: "ossUpload/getFileUploadParam",
      payload: {
        key: "ossUpload@getFileUploadParam",
        apiParams: { roleSessionName: sys_endpoint, bucketName: sys_ali_bucket },
      },
    });
    this.doAction({
      path: "contentManage/detailInfo",
      payload: {
        key: "detailInfo",
        apiParams: { id: this.detailInfo.id },
      },
    });
  }

  // 监听属性和状态的变化
  propsAndStateOnChange = {
    detailInfo: this._detailInfo.bind(this),
    getFileUploadParam: this._getFileUploadParam.bind(this),
  };
  _getFileUploadParam(nextProps, nextState) {
    const { getFileUploadParam } = nextProps;
    if (getFileUploadParam["success"] && getFileUploadParam["data"]) {
      Session.add(sys_ali_key, getFileUploadParam["data"])
      return true;
    }
    return false;
  }

  _detailInfo(nextProps, nextState) {
    const { detailInfo } = nextProps;
    if (detailInfo["success"] && detailInfo["data"]) {
      let contentTextList = detailInfo["data"]['contentTextList']
      if (contentTextList && contentTextList.length) {
        contentTextList = contentTextList.sort((a, b) => { return a.id - b.id })
      }
      nextState.record = { ...this.detailInfo, ...detailInfo.data, contentTextList };
      return true;
    }
    return false;
  }

  handleDownLoad = () => {
    this.doAction({
      path: "addContentRecord/add",
      payload: {
        key: "addContentRecord@add",
        apiParams: {
          contentId: this.id,
          operationType: 0,
        },
      },
    });
  }

  _content = () => {
    const { record } = this.state;
    switch (this.detailInfo.contentType) {
      case 1:
        return <Article {...record} />;
      case 2:
        return <Slide {...record} />;
      case 3:
        return <Video {...record} />;
      case 4:
        return <Document {...record} />;
      case 5:
        return <File {...record}  handleDownLoad={this.handleDownLoad}  />;
    }
  };

  _render() {
    return (
      <div
        style={{
          width: "75%",
          padding: 20,
          margin: "0 auto",
          backgroundColor: "#fff",
        }}
      >
        <Header {...this.state.record} />
        {this._content()}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { contentManage, addContentRecord, ossUpload } = state;
  const detailInfo = modelUtils.getModelEntity(contentManage, "detailInfo");
  const add = modelUtils.getModelEntity(addContentRecord, "addContentRecord@add");
  const getFileUploadParam = modelUtils.getModelEntity(ossUpload, "ossUpload@getFileUploadParam");
  const load = modelUtils.getLoadingState(state, "contentManage");
  return {
    detailInfo,
    add,
    getFileUploadParam,
    ...load,
  };
};

export default connect(mapStateToProps)(ContentPreview);

function Header({
  title,
  categoryNames,
  author,
  releaseTime,
  lookCount,
}) {
  return (
    <React.Fragment>
      <Title level={4} style={{ marginBottom: 20 }}>
        {title}
      </Title>
      {categoryNames && categoryNames.length
        ? categoryNames.split(",").map((val) => (
          <WizTag key={val} color="#2db7f5" style={{ margin: 5 }}>
            {val}
          </WizTag>
        ))
        : null}
      <div
        className="flex"
        style={{ justifyContent: "space-between", marginTop: 20 }}
      >
        <div>作者：{author}</div>
        <div>
          <span style={{ marginRight: 15 }}>
            <WizIcon type="history" /> {releaseTime}
          </span>
          <span>
            <WizIcon type="eye" /> {lookCount}
          </span>
        </div>
      </div>
      <WizDivider />
    </React.Fragment>
  );
}

// 文章
function Article({ contentTextList }) {
  return (
    <div className="content-view-img"
      dangerouslySetInnerHTML={{
        __html: contentTextList && contentTextList[0].contentDetail,
      }}
    ></div>
  );
}

// 图片
function Slide({ contentTextList, watermark, hiddenType = 0 }) {
  return contentTextList && contentTextList.length ? (
    <Swiper style={{ height: 500 }} slidesPerView={1} navigation autoplay>
      {contentTextList.map((val, index) => (
        <SwiperSlide key={val.id}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={watermark ? getOssFilePathWatermark(val.fileId) : getOssFilePath(val.fileId)} />
          </div>
          <div>
            <div>
              <em>{index + 1}</em>/{contentTextList.length}
            </div>
            <div>{val.contentDetail}</div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  ) : null;
}

// 视频
function Video({ contentTextList, watermark, id, title, hiddenType }) {
  const watermarkStyle = {
    color: "white",
    padding: "5px",
    position: "absolute",
    top: "30px",
    right: "10px",
    fontSize: "16px",
  };
  if (!contentTextList || (contentTextList instanceof Array && contentTextList.length === 0)) return null;
  const fileUri = contentTextList[0].fileUri;
  const url = fileUri ? getOssUrlBySuffix(fileUri) : contentTextList[0].url;
  const sources = {
    sd: {
      play_url: url,
    }
  };
  const videoProps = {
    id,
    title,
    sources,
    locale: 'zh-Hans',
    disablePictureInPicture: true,
    initialObjectFit: 'contain',
    standalone: true,
    autoplay: true,
    shouldObserveResize: true,
  };
  return (
    <div className="video-wrp">
      <PlayerContainer {...videoProps}>
      </PlayerContainer>
    </div>
  );
}

function Document({ contentTextList = [], releaseTime, watermark, id, title, hiddenType }) {
  const _contentTextList = JSON.parse(JSON.stringify(contentTextList));
  const dataSource = _contentTextList.map((val) => {
    if (!val.fileName && val.fileName !== 0) return {}
    const index = val.fileName.lastIndexOf('.')
    const fileName = val.fileName.substr(0, index)
    const attachmentFormat = index === 0 ? '' : val.fileName.substr(index + 1)
    return {
      fileUri: getOssUrlBySuffix(val.fileUri),
      fileName: fileName,
      originalFileName: val.fileName,
      attachmentFormat: attachmentFormat.toLocaleUpperCase(),
      fileSize: `${(val.fileSize / 1024).toFixed(1)}KB`,
      uploadTime: releaseTime,
    };
  });

  const tableProps = {
    pagination: false,
    columns: documentColumns(),
    dataSource: dataSource || [],
  };

  return (
    <React.Fragment>
      <h2 className="file-title">文档清单</h2>
      <WizTable {...tableProps} />
    </React.Fragment>
  );
}

// 文件下载
function File({ contentTextList = [], releaseTime, handleDownLoad, hiddenType = 0 }) {
  const _contentTextList = JSON.parse(JSON.stringify(contentTextList));
  const dataSource = _contentTextList.map((val) => {
    if (!val.fileName && val.fileName !== 0) return {}
    // fileName = val.fileName.split(".");
    const index = val.fileName.lastIndexOf('.')
    const fileName = val.fileName.substr(0, index)
    const attachmentFormat = index === 0 ? '' : val.fileName.substr(index + 1)
    return {
      fileuri: getOssUrlBySuffix(val.fileUri),
      filename: fileName,
      attachmentFormat: attachmentFormat.toLocaleUpperCase(),
      filesize: `${(val.fileSize / 1024).toFixed(1)}KB`,
      uploadTime: releaseTime,
    };
  });

  const tableProps = {
    pagination: false,
    columns: downLoadColumns(handleDownLoad),
    dataSource: dataSource || [],
  };
  return (
    <React.Fragment>
      <h2 className="file-title">文件清单</h2>
      <WizTable {...tableProps} />
    </React.Fragment>
  );
}
